export * from '@entities/thiet-bi/thiet-bi.routes';
export * from '@entities/thiet-bi/thiet-bi.service';
export * from '@entities/thiet-bi/thiet-bi/thiet-bi.component';
